export const stringToSlug = (name: string) => {
  return name
    .toLowerCase()
    .replaceAll(' ', '-')
    .replaceAll(/[^A-Za-z0-9-]+/g, '')
    .replace(/-$/, '');
};

// The name a factiii shows in a <title>, heading or schema `name`. The
// Wikipedia bot stores article titles verbatim ("List_of_flight_airspeed_
// records"), so underscores read as spaces here; the stored name is untouched.
export const factiiiDisplayName = (name: string): string =>
  name.replaceAll('_', ' ').trim();

export function extractYouTubeVideoId(url: string): string | null {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/)([^&\n?#]+)/,
    /youtube\.com\/watch\?.*v=([^&\n?#]+)/,
    /youtu\.be\/([^&\n?#]+)/,
    /youtube\.com\/embed\/([^&\n?#]+)/,
    /youtube\.com\/v\/([^&\n?#]+)/
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match?.[1]) {
      return match[1];
    }
  }

  return null;
}

export function isYouTubeUrl(url: string): boolean {
  return /(?:youtube\.com|youtu\.be)/.test(url);
}

// `crypto.randomUUID` exists only in a secure context — HTTPS or localhost — so it
// is undefined when the dev server is reached over plain HTTP on a LAN address
// (e.g. http://192.168.1.200:3001), where touching it crashed sign-in.
// `crypto.getRandomValues` has no such restriction and is present in every browser
// and in Node, so fall back to it and format the bytes as an RFC 4122 v4 UUID.
// Universal so both the client and server-side callers (contentFilter) share one
// implementation. The same guard is applied inline in auth/Login.tsx (nonce) and
// domains/avatar.ts (avatar seed).
export function randomUuid(): string {
  const c = globalThis.crypto;
  if (typeof c?.randomUUID === 'function') {
    return c.randomUUID();
  }

  // 16 random bytes, then set the version (4) and variant (10xx) bits so the
  // result is a well-formed v4 UUID, not just random hex.
  const bytes = new Uint8Array(16);
  c.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
  return (
    hex.slice(0, 4).join('') +
    '-' +
    hex.slice(4, 6).join('') +
    '-' +
    hex.slice(6, 8).join('') +
    '-' +
    hex.slice(8, 10).join('') +
    '-' +
    hex.slice(10, 16).join('')
  );
}
